import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {  RootState } from '@/projects/shuttle/store/store';
import { axiosInstance } from '@/utils/AxiosInstance';


export type RouteBusStopType = {
  bus_stop_id: number;
  name: string;
  arrival_time: string;
};

export type lastSuccessfulSubscriptionType = {
  tour_id: number;
  pickup_rbs: RouteBusStopType;
  dropoff_rbs: RouteBusStopType;
};

type settingsRequestGetType = {
  phone: string;
};

type settingsRequestUpdateCityType = {
  phone: string;
  city_id: number;
};

export type settingsResponseType = {
  city: {
    id: number;
    name: string;
  } | null;
  latest_subscription: lastSuccessfulSubscriptionType | null;
}

interface SettingsState {
  city: {
    id: number;
    name: string;
  } | null;
  latestSubscription: lastSuccessfulSubscriptionType | null;
  loading: boolean;
  error: string | null;
}

const initialState: SettingsState = {
  city: null,
  latestSubscription: null,
  loading: false,
  error: null,
};



export const getSettings = createAsyncThunk<settingsResponseType, settingsRequestGetType>(
  'settings/getSettings',
  async (data: settingsRequestGetType) => {
    return await axiosInstance.get<settingsResponseType>(
      `/settings?phone=${encodeURIComponent(data.phone)}`
    );
  }
);

export const updateCity = createAsyncThunk<settingsResponseType, settingsRequestUpdateCityType>(
  'settings/updateCity',
  async (data: settingsRequestUpdateCityType) => {
    return await axiosInstance.patch('/settings', data);
  }
);

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    clearSettings: (state) => {
      state.city = null;
      state.latestSubscription = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch settings
      .addCase(getSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.city = action.payload.city;
        state.latestSubscription = action.payload.latest_subscription;
      })
      .addCase(getSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to get settings';
      })
      // Update city
      .addCase(updateCity.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCity.fulfilled, (state, action) => {
        state.loading = false;
        state.city = action.payload.city;
      })
      .addCase(updateCity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to update city';
      });
  },
});

export const { clearSettings } = settingsSlice.actions;

export const settingsSelector = (state: RootState) => state.settingsReducer;

export default settingsSlice.reducer;